@if (facade.showIntro$ | async) {
  <div class="chat-wrapper-intro">
    <div class="chat-intro">
      {{ literalsFacade.literals.literals['liquid.homepage.alio.welcomemsg'] }}
    </div>
    <div class="chat-input-container">
      <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="6"
        class="chat-input"
        placeholder="{{
          literalsFacade.literals.literals['liquid.homepage.alio.inputparsequestionplaceholder']
        }}"
        (input)="createSession($event)"
        (keydown.enter)="sendQuestion($event)"
        [value]="facade.message$ | async"
        [disabled]="facade.disableChatResponse$ | async"
      ></textarea>
      <button
        mat-flat-button
        class="chat-send-btn"
        (click)="sendQuestion($event)"
        [disabled]="facade.disableChat"
      >
        {{ literalsFacade.literals.literals['liquid.homepage.alio.sendquestionbtn'] }}
      </button>
    </div>
    @if (facade.usage$ | async; as usage) {
      <div class="chat-usage">{{ formatTokens(usage.tokens.total) }} / {{ formatTokens(usage.limit) }} tokens</div>
    }
    @if (facade.showError$ | async) {
      <div class="error">Something went wrong. Please try again later.</div>
    }
  </div>
}

@if (!(facade.showIntro$ | async)) {
  <div class="chat-wrapper">
    <div class="chat-container" #chatContainer (scroll)="onScroll(chatContainer)">
      @for (msg of facade.messages$ | async; track msg) {
        <div [ngClass]="msg.sender">
          @defer (on immediate) {
            <markdown [data]="msg.text"></markdown>
          } @placeholder {
            <span>{{ msg.text }}</span>
          }
        </div>
      }
      @for (msg of facade.typing$ | async; track msg) {
        <div [ngClass]="msg.sender">
          @defer (on immediate) {
            <markdown [data]="msg.text"></markdown>
          } @placeholder {
            <span>{{ msg.text }}</span>
          }
        </div>
      }
      @if (facade.disableChatResponse$ | async) {
        <div class="typing-indicator"><span></span><span></span><span></span></div>
      }
    </div>
    <div class="chat-input-wrapper">
      @if (showScrollDownButton) {
        <button class="scroll-to-bottom" (click)="scrollToBottom(chatContainer)">⬇</button>
      }
      @if (facade.disableChatResponse$ | async) {
        <mat-progress-bar
          class="chat-progress-bar"
          color="primary"
          mode="indeterminate"
        ></mat-progress-bar>
      }
      <div class="chat-input-container">
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="6"
          class="chat-input"
          placeholder="{{
            literalsFacade.literals.literals['liquid.homepage.alio.inputparsequestionplaceholder']
          }}"
          (input)="createSession($event)"
          (keydown.enter)="sendQuestion($event)"
          [value]="facade.message$ | async"
          [disabled]="facade.disableChatResponse$ | async"
        ></textarea>
        <button
          mat-flat-button
          class="chat-send-btn"
          (click)="sendQuestion($event)"
          [disabled]="facade.disableChatResponse$ | async"
        >
          {{ literalsFacade.literals.literals['liquid.homepage.alio.sendquestionbtn'] }}
        </button>
      </div>
      @if (facade.usage$ | async; as usage) {
        <div class="chat-usage">{{ formatTokens(usage.tokens.total) }} / {{ formatTokens(usage.limit) }} tokens</div>
      }
    </div>
  </div>
}
